import { i18n } from "../../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import barcodeService from '../../../services/barcode.service'
import labelBuilderService from '../../../services/labelBuilder.service'
import { RootState } from '../../../store'
import {
  BarcodeElement,
  replaceBarcodeElementColor,
  replaceBarcodeElementFormat,
  replaceBarcodeElementImage,
  replaceBarcodeOpacity,
} from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputColor from '../../InputColor'
import Select from '../../Select'
import ContentProperty from './ContentProperty'
import InputText from '../../InputText'
import PositionProperty from './PositionProperty'

interface Props {
  selectedElement: BarcodeElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class BarcodeProperties extends Component<CombinedProps> {

  getDefaultValueByBarcodeType(type: String): string {
    switch(type){
      case 'azteccode':         return '976298112359';
      case 'rationalizedCodabar': return 'A1234567890B';
      case 'interleaved2of5':   return '123456789';
      case 'itf14':             return '1234567890123';
      case 'code39':            return '1234TEXT567890';
      case 'code93':            return '123USETEXT456';
      case 'code128':           return '12345TEXT7890';
      case 'gs1-128':           return '(01)01234567891231';
      case 'datamatrix':        return '12345TEXT67890';
      case 'ean13':             return '123456789012';
      case 'databarstacked':    return '(01)01234567891231';
      case 'pdf417':            return '123456TEXT7890';
      case 'upca':              return '123456789012';
      case 'upce':              return '357122';
      case 'sscc18':            return '(00)00123456000000001';
      default:                  return '';
    }
  }

  handleInputChange = (name: string, value: string) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    if (name === 'type') {
      this.props.replaceBarcodeElementFormat(selectedElement.id, value)
      barcodeService.generateBarcode(value, this.getDefaultValueByBarcodeType(value), selectedElement.color, (image) => {
        this.props.replaceBarcodeElementImage(selectedElement.id, image)
      })
    }
    if (name === 'opacity') this.props.replaceBarcodeOpacity(selectedElement.id, Number(value))
    if (name === 'color') {
      this.props.replaceBarcodeElementColor(selectedElement.id, value)
      barcodeService.generateBarcode(selectedElement.format, selectedElement.text, value, (image) => {
        this.props.replaceBarcodeElementImage(selectedElement.id, image)
      })
    }
  }

  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'barcode') return null
    return (
        <Fragment>
          <Heading
              className="mb-1"
              text={i18n("Barcode")}
              size="small" />
          <PositionProperty
              elementId={selectedElement.id}
              x={selectedElement.x}
              y={selectedElement.y}
          />
          <Select
              name="type"
              value={selectedElement.format}
              options={labelBuilderService.barcodeTypeSelectOptions}
              label={i18n("Type")}
              onChange={this.handleInputChange} />
          <InputText
              type="number"
              name="opacity"
              value={String(selectedElement.opacity)}
              label={i18n("Transparency")}
              onChange={this.handleInputChange}
              enforceLimits={true} />
          <InputColor
              name="color"
              value={selectedElement.color || '#000000'}
              label={i18n('Color')}
              onChange={this.handleInputChange} />
          <ContentProperty />
        </Fragment>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {}
}

const mapDispatchToProps = {
  replaceBarcodeElementFormat,
  replaceBarcodeElementImage,
  replaceBarcodeElementColor,
  replaceBarcodeOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(BarcodeProperties)
